export default "__VITE_ASSET__BgyGleo8__"